import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import GreetingMembershipService from "../../../services/GreetingMembershipService";
import GreetingMembership from "../../../models/GreetingMembership";
import { CreateGreetingMembership } from "./ui/buttons";
import GreetingMembershipsTable from "./ui/greeting-memberships-table";
import GreetingMembershipsSkeleton from "./skeleton/greeting-memberships-skeleton";

export default function GreetingMembershipsPage() {
  const [searchParams] = useSearchParams();
  const api = new GreetingMembershipService();
  const [items, setItems] = useState<GreetingMembership[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void fetchItems();
  }, [searchParams.get("reload")]);

  const fetchItems = async () => {
    try {
      const data = await api.getGreetingMemberships();
      setItems(data);
    } catch (error) {
      console.error("Error fetching greeting memberships:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Greeting Memberships", href: "/admin/greeting-memberships" },
        ]}
      />
      <CreateGreetingMembership />
      {loading ? (
        <GreetingMembershipsSkeleton />
      ) : (
        <GreetingMembershipsTable items={items} />
      )}
    </div>
  );
}
